import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Chip,
  Tooltip,
  Autocomplete,
  TextField,
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Button } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

const api = axios.create({
  baseURL: "https://suadesarrollo.azurewebsites.net/api",
  auth: {
    username: "BasicAuth@icontec.org",
    password: "yQLzqmR7eZSuAmQZUqhY",
  },
});

function AsignarOm() {
  const { idSolicitud, institucion } = useParams();

  const [evaluadores, setEvaluadores] = useState([]);
  const [evaluadoresSeleccionados, setEvaluadoresSeleccionados] = useState([]);
  const [omisiones, setOmisiones] = useState([]);
  const [loading, setLoading] = useState(false);

  const usuarioLiderId = 111;

  /* =========================
     OBTENER EVALUADORES
  ========================== */
  useEffect(() => {
    const obtenerEvaluadores = async () => {
      try {
        const respuesta = await api.get(
          `/QEquipoUsuario?SolicitudId=${idSolicitud}`,
        );

        console.log("Respuesta de QEquipoUsuario:", respuesta.data);

        const evaluadoresValidos = (respuesta.data || [])
          .filter((e) => {
            const id = e.evaluadorId || e.id;
            return id && id > 0;
          })
          .map((e) => ({
            ...e,
            evaluadorId: e.evaluadorId || e.id,
          }));

        setEvaluadores(evaluadoresValidos);
      } catch (error) {
        console.error("Error obteniendo evaluadores:", error);
        console.error("Respuesta del servidor:", error.response?.data);
      }
    };

    if (idSolicitud) {
      obtenerEvaluadores();
    }
  }, [idSolicitud]);

  /* =========================
     OBTENER OPORTUNIDADES DE MEJORA
  ========================== */
  const fetchOm = async () => {
    try {
      const respuesta = await api.get(`/ObtenerPriorizadas/${institucion}`);

      console.log("Respuesta de ObtenerPriorizadas:", respuesta.data);

      const dataNormalizada = (respuesta.data || []).map((item) => ({
        ...item,
        asignados: (item.asignados || []).map((a) => ({
          ...a,
          evaluadorId: a.evaluadorId || a.id,
        })),
      }));

      setOmisiones(dataNormalizada);
    } catch (error) {
      console.error("Error obteniendo oportunidades de mejora:", error);

      console.error("Respuesta del servidor:", error.response?.data);
    }
  };

  useEffect(() => {
    if (institucion) {
      fetchOm();
    }
  }, [institucion]);

  /* =========================
     ELIMINAR EVALUADOR
  ========================== */
  const eliminarEvaluador = async (omId, evaluadorId) => {
    const confirmacion = await Swal.fire({
      title: "¿Eliminar evaluador?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!confirmacion.isConfirmed) return;

    try {
      const respuesta = await api.delete(
        `/EliminaOmAuditor/${omId}/${evaluadorId}`,
      );

      console.log("Respuesta de EliminaOmAuditor:", respuesta.data);

      setOmisiones((prev) =>
        prev.map((om) => {
          if (om.o.id !== omId) return om;

          return {
            ...om,
            asignados: (om.asignados || []).filter(
              (e) => e.evaluadorId !== evaluadorId,
            ),
          };
        }),
      );

      await Swal.fire({
        title: "Evaluador eliminado",
        text: "El evaluador fue eliminado correctamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error("Error eliminando evaluador:", error);

      console.error("Respuesta del servidor:", error.response?.data);

      await Swal.fire({
        title: "Error",
        text:
          error.response?.data?.message ||
          error.response?.data?.mensaje ||
          "No se pudo eliminar el evaluador.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  /* =========================
     FORMATEAR RESPUESTA DEL BACKEND
  ========================== */
  const formatearRespuesta = (data) => {
    if (data === null || data === undefined || data === "") {
      return "El servidor no devolvió contenido en la respuesta.";
    }

    if (typeof data === "string") {
      return data;
    }

    try {
      return JSON.stringify(data, null, 2);
    } catch (error) {
      console.error("Error formateando respuesta:", error);

      return String(data);
    }
  };

  /* =========================
     MOSTRAR RESPUESTA EN SWEETALERT
  ========================== */
  const mostrarRespuestaAsignacion = async (respuesta) => {
    const datos = respuesta.data;
    const mensaje = formatearRespuesta(datos);

    console.group("RESPUESTA DEL ENDPOINT AsignaOmAuditores");

    console.log("Respuesta completa de Axios:", respuesta);
    console.log("Código HTTP:", respuesta.status);
    console.log("Datos del backend:", datos);

    console.groupEnd();

    await Swal.fire({
      title: "Respuesta de asignación de OM",
      html: `
        <div style="text-align: left;">
          <p>
            <strong>Estado HTTP:</strong>
           la om se actulizo en estado 
          </p>
          <pre style="
            text-align: left;
            white-space: pre-wrap;
            overflow-wrap: anywhere;
            word-break: break-word;
            max-height: 350px;
            overflow-y: auto;
            padding: 12px;
            border-radius: 6px;
            background: #f5f5f5;
            color: #222;
            font-size: 13px;
          ">${mensaje
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")}</pre>
        </div>
      `,
      icon: "success",
      confirmButtonText: "Aceptar",
      width: "650px",
    });
  };

  /* =========================
     GUARDAR ASIGNACIÓN
  ========================== */
  const guardarAsignacion = async (rows, tipo) => {
    if (!rows || rows.length === 0) {
      await Swal.fire(
        "Atención",
        "Debe seleccionar al menos una oportunidad de mejora.",
        "warning",
      );
      return;
    }

    if (evaluadoresSeleccionados.length === 0) {
      await Swal.fire(
        "Atención",
        "Debe seleccionar al menos un evaluador.",
        "warning",
      );
      return;
    }

    setLoading(true);

    try {
      /*
       * 1. CONSTRUIR PAYLOAD
       *
       * Cada OM seleccionada se asigna a cada evaluador
       * seleccionado, conservando la lógica original.
       */
      const payload = rows.flatMap((row) =>
        evaluadoresSeleccionados.map((ev) => ({
          OportunidadMejoraId: row.original.o.id,
          EvaluadorId: ev.evaluadorId,
          SolicitudId: Number(idSolicitud),
          UsuarioId: usuarioLiderId,
        })),
      );

      console.group("PROCESO DE ASIGNACIÓN DE OM");

      console.log("Solicitud:", idSolicitud);
      console.log("Institución:", institucion);
      console.log("Tipo de OM:", tipo === 1 ? "ASISTENCIAL" : "APOYO");
      console.log("OM seleccionadas:", rows);
      console.log("Evaluadores seleccionados:", evaluadoresSeleccionados);
      console.log("Payload:", payload);

      console.groupEnd();

      /*
       * 2. ACTUALIZAR CATEGORIZACIÓN
       *
       * tipo = 1: ASISTENCIAL
       * tipo = 2: APOYO
       */
      const respuestasCategorizacion = await Promise.all(
        rows.map((row) =>
          api.put(`/ActualizaCategorizacion/${row.original.o.id}`, {
            asistencial: tipo,
          }),
        ),
      );

      console.log(
        "Respuestas de ActualizaCategorizacion:",
        respuestasCategorizacion.map((r) => ({
          status: r.status,
          data: r.data,
        })),
      );

      /*
       * 3. ASIGNAR EVALUADORES
       *
       * Se conserva el endpoint original y el método PUT.
       */
      const respuestaAsignaOmAuditores = await api.put(
        "/AsignaOmAuditores",
        payload,
      );

      /*
       * 4. MOSTRAR LA RESPUESTA REAL DEL ENDPOINT
       *
       * Ya no se muestra el mensaje fijo
       * "Asignación guardada correctamente".
       */
      await mostrarRespuestaAsignacion(respuestaAsignaOmAuditores);

      /*
       * 5. RECARGAR LA TABLA
       */
      await fetchOm();
    } catch (error) {
      console.error("Error durante la asignación de OM:", error);

      let mensajeError = "Ocurrió un error durante el proceso de asignación.";

      if (error.response) {
        console.group("ERROR DEL BACKEND");

        console.error("Endpoint:", error.config?.url);
        console.error("Método:", error.config?.method);
        console.error("Estado HTTP:", error.response.status);
        console.error("Respuesta del servidor:", error.response.data);

        console.groupEnd();

        mensajeError = formatearRespuesta(error.response.data);
      } else if (error.request) {
        mensajeError =
          "Se realizó la solicitud, pero no se recibió respuesta del servidor.";
      } else {
        mensajeError = error.message || mensajeError;
      }

      await Swal.fire({
        title: "Error en la asignación",
        html: `
          <pre style="
            text-align: left;
            white-space: pre-wrap;
            overflow-wrap: anywhere;
            max-height: 350px;
            overflow-y: auto;
            font-size: 13px;
          ">${mensajeError
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")}</pre>
        `,
        icon: "error",
        confirmButtonText: "Aceptar",
        width: "650px",
      });
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     COLUMNAS
  ========================== */
  const columns = useMemo(
    () => [
      {
        accessorKey: "o.id",
        header: "ID",
        size: 60,
      },
      {
        accessorFn: (row) => row.o?.descripcion || "",
        id: "descripcion",
        header: "Descripción",
        Cell: ({ cell }) => {
          const texto = cell.getValue() || "";

          return (
            <Tooltip title={texto}>
              <span
                style={{
                  maxWidth: 320,
                  display: "inline-block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                }}
              >
                {texto}
              </span>
            </Tooltip>
          );
        },
      },
      {
        accessorFn: (row) => row.o?.asistencial,
        id: "tipoOm",
        header: "Tipo",
        Cell: ({ cell }) => {
          const valor = cell.getValue();

          if (valor === 2) {
            return <Chip label="APOYO" color="secondary" size="small" />;
          }

          if (valor === 1) {
            return <Chip label="ASISTENCIAL" color="primary" size="small" />;
          }

          return <Chip label="SIN DEFINIR" size="small" />;
        },
      },
      {
        accessorFn: (row) => row.asignados || [],
        id: "evaluadores",
        header: "Evaluadores",
        Cell: ({ cell, row }) => {
          const evaluadoresAsignados = cell.getValue();

          if (!evaluadoresAsignados || evaluadoresAsignados.length === 0) {
            return <Chip label="Sin asignar" size="small" />;
          }

          return (
            <Box
              sx={{
                display: "flex",
                gap: 0.5,
                flexWrap: "wrap",
              }}
            >
              {evaluadoresAsignados.map((e) => (
                <Chip
                  key={`${row.original.o.id}-${e.evaluadorId}`}
                  label={e.nombre || `Evaluador ${e.evaluadorId}`}
                  size="small"
                  onDelete={() =>
                    eliminarEvaluador(row.original.o.id, e.evaluadorId)
                  }
                  color="error"
                  variant="outlined"
                />
              ))}
            </Box>
          );
        },
      },
      {
        accessorKey: "o.omPadreId",
        header: "N° Agrupación",
        size: 100,
      },
    ],
    [],
  );

  /* =========================
     RENDER
  ========================== */
  return (
    <div className="container mt-3">
      <div className="card shadow">
        <div className="card-header">
          <h6 className="text-primary font-weight-bold">
            Asignar Oportunidades de Mejora
          </h6>
        </div>

        <div className="card-body">
          <Autocomplete
            multiple
            options={evaluadores}
            getOptionLabel={(opt) => opt.nombre || ""}
            value={evaluadoresSeleccionados}
            onChange={(event, valores) => setEvaluadoresSeleccionados(valores)}
            isOptionEqualToValue={(opt, val) =>
              opt.evaluadorId === val.evaluadorId
            }
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  label={option.nombre}
                  {...getTagProps({ index })}
                  key={option.evaluadorId}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Evaluadores"
                placeholder="Seleccione evaluadores"
                className="mb-3"
              />
            )}
          />

          <MaterialReactTable
            columns={columns}
            data={omisiones}
            getRowId={(row) => String(row.o.id)}
            localization={MRT_Localization_ES}
            enableRowSelection
            enableMultiRowSelection
            positionToolbarAlertBanner="bottom"
            initialState={{
              showColumnFilters: true,
            }}
            renderDetailPanel={({ row }) => (
              <Box sx={{ padding: 2 }}>
                <Typography>
                  <b>Descripción completa:</b>
                </Typography>

                <Typography>{row.original.o?.descripcion || ""}</Typography>
              </Box>
            )}
            renderTopToolbarCustomActions={({ table }) => (
              <div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                <Button
                  disabled={!table.getIsSomeRowsSelected() || loading}
                  onClick={() =>
                    guardarAsignacion(table.getSelectedRowModel().flatRows, 2)
                  }
                >
                  {loading ? "PROCESANDO..." : "GUARDAR APOYO"}
                </Button>

                <Button
                  disabled={!table.getIsSomeRowsSelected() || loading}
                  onClick={() =>
                    guardarAsignacion(table.getSelectedRowModel().flatRows, 1)
                  }
                >
                  {loading ? "PROCESANDO..." : "GUARDAR ASISTENCIAL"}
                </Button>
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
}

export default AsignarOm;
